import React from 'react';
import classNames from 'classnames';
import Card from "@scentregroup/ui/components/card";
import Container from "@scentregroup/ui/components/container";
import { CustomThemeContext, BasicPageContext } from '../../context';
import Article from '../article';
import InfoAccordion from '../info-accordion';
import style from '../feature/index.module.scss';
import ServiceUtilityBox from '../service-utility-box';
import accordionEntriesFromModules from './accordion-entries-from-modules';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ParkingModules = _ref => {
  let {
    centre,
    modules,
    centreTradingHours
  } = _ref;
  return /*#__PURE__*/_jsx(CustomThemeContext.Consumer, {
    children: themeOption => /*#__PURE__*/_jsx(BasicPageContext.Consumer, {
      children: isBasicPage => /*#__PURE__*/_jsx("div", {
        className: classNames(style.Feature, style.ParkingFeature, style.placeholder, style.evolved, {
          [style.Grey]: themeOption.luxury
        }),
        "data-id": "parking-modules_index_ParkingModules_div",
        children: /*#__PURE__*/_jsxs(Container, {
          centred: true,
          type: "large",
          className: classNames(style.Container),
          "data-id": "parking-modules_index_ParkingModules_div_Container",
          children: [/*#__PURE__*/_jsx(Card, {
            className: style.Card,
            "data-id": "parking-modules_index_ParkingModules_Container_Card",
            children: /*#__PURE__*/_jsx(Article, {
              heading: isBasicPage ? '' : 'Parking',
              headingType: "medium",
              "data-id": "parking-modules_index_ParkingModules_Card_Article",
              children: /*#__PURE__*/_jsx(InfoAccordion, {
                metaRows: accordionEntriesFromModules(modules, centre),
                purpose: "Parking information",
                theme: "parking",
                "data-id": "parking-modules_index_ParkingModules_Article_InfoAccordion"
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: style.Sidebar,
            "data-id": "parking-modules_index_ParkingModules_Container_div",
            children: /*#__PURE__*/_jsx(ServiceUtilityBox, {
              centre: centre,
              centreTradingHours: centreTradingHours,
              "data-id": "parking-modules_index_ParkingModules_div_ServiceUtilityBox"
            })
          })]
        })
      })
    })
  });
};
export default ParkingModules;